var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-modal',{ref:"modal",attrs:{"visible":_vm.visible,"size":"sm","return-focus":_vm.returnFocus,"no-enforce-focus":"","no-fade":"","centered":"","no-close-on-backdrop":"","no-close-on-esc":"","busy":"","dialog-class":"loading-modal"}},[_c('div',{staticClass:"loading"})])
}
var staticRenderFns = []

export { render, staticRenderFns }